<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <data-view-sidebar ref="dataSidebar" :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
      :data="sidebarData" />
    <vs-popup id="deletePopup" class="holamundo" title="Ödeme Tipi Sil" :active.sync="deletePopupActive"
      v-esc="escapeDelete">
      <div class="w-full">
        <vs-row vs-type="flex" vs-w="12">
          <p>Bu Ödeme Tipini Silmek İstediğinize Eminmisiniz ? </p>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
          <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç
          </vs-button>
          <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
            @click="deleteData(deletedId)">
            Sil
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
    <vs-table ref="table" :data="paymentMethods" v-model="selected">

      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <vs-row id="panelHeaderRow" vs-type="flex" vs-w="12" vs-justify="space-between">
          <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isCenterBranch() && isNewPaymentMethodPermission" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni Ödeme Tipi" position="top">
                  <vs-button @click="addNewData" class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent" icon-pack="feather" icon="icon-plus">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>

      <template slot="thead">

        <vs-th class="w-5/12">
          <vs-button color="primary" type="flat">İsim
          </vs-button>
        </vs-th>
        <vs-th class="w-4/12">
          <vs-button icon-pack="feather" type="flat">Ana Ödeme Tipi
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12" v-if="AppActiveUser.branch.id==1 && isDeletePaymentMethodPermission">
          <vs-button icon-pack="feather" type="flat">İşlem
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="w-5/12">
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>
            <vs-td class="w-5/12">
              <p class="product-category" v-if="tr.originPaymentMethod != null">{{ tr.originPaymentMethod.name }}</p>
            </vs-td>
            <vs-td class="whitespace-no-wrap w-1/12" v-if="AppActiveUser.branch.id==1 && isDeletePaymentMethodPermission">
              <feather-icon v-if="tr.type == 'Single'" icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click.stop="deletedId = tr.id;deletePopupActive = true;" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import DataViewSidebar from "./NewPaymentMethodAdd.vue";
  import {
    deletePaymentMethod,
    getPaymentMethodList
  } from "@/api/PaymentMethod";
  import {isGranted} from "@/utils/auth";
  export default {
    components: {
      DataViewSidebar
    },
    data() {
      return {
        deletedId: null,
        deletePopupActive: false,
        selected: "",

        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        paymentMethods: []
      };
    },
    computed: {
      AppActiveUser() {
        return this.$store.state.AppActiveUser;
      },
      isNewPaymentMethodPermission(){
      return isGranted("payment_method_write")
    },
    isDeletePaymentMethodPermission(){
      return isGranted("payment_method_delete")
    }
    },
    methods: {
      escapeDelete() {
        if (this.deletePopupActive == true) {
          this.deletePopupActive = false;
          this.deletedId = null;
        }
      },
      addNewData() {
        this.sidebarData = {};
        this.toggleDataSidebar(true);
      },
      deleteData(id) {
        deletePaymentMethod(id).then(res => {
          if (res && res.status == 200) {
            let paymentMethodIndex = this.paymentMethods.findIndex((p) => p.id == id)
            this.paymentMethods.splice(paymentMethodIndex, 1);
            this.deletePopupActive = false;
            this.deletedId = null;
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Ödeme Tipi Silme Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Silme İşlemi Başarısız !"
            });
          }
        }).catch(x => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      },
      editData(data) {
        this.sidebarData = data;
        this.toggleDataSidebar(true);
      },
      toggleDataSidebar(val = false) {
        this.addNewDataSidebar = val;
        val == false ? this.selected = "" : null;
      },
      getPaymentMethodList: async function () {
        try {
          let response = await getPaymentMethodList();
          this.paymentMethods = response;
          this.$refs.dataSidebar.paymentMethods = response;
        } catch {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: e.message
          });
        }
      },
    },
    created() {
      this.getPaymentMethodList();
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 13) {
          if (this.deletePopupActive) this.deleteData(this.deletedId);
        }
      });
    },
    mounted() {
      this.isMounted = true;
    },
    watch: {
      selected: function (val) {
        if (val != "" && this.AppActiveUser.branch.id == 1 && val.type == 'Single' && isNewPaymentMethodPermission) this.editData(val);
      }
    }
  };

</script>

<style>
  .selectable:hover {
    cursor: pointer;
    box-shadow: 2px 2px 5px #000;
  }

  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

</style>
